<template lang="pug">
  v-row(no-gutters)
    v-col(cols=12).px-1.pt-3
      v-card.px-2(flat)
        v-row.mx-1
          v-col(
            cols='12'
            sm='6'
          )
            n-btn-toggle-check(
              v-if='firstTab.userReward!==undefined'
              v-model="selectType"
              :index-value="1"
              :text="`${(firstTab.number_type || {}).name}`"
              :append-amount="firstTab.userReward"
              @click="changeStatus(firstTab.number_type.id,firstTab.number_type.name)"
            )
          v-col(cols='12', sm='6')
            n-btn-toggle-check(
              v-if='!secondTab.Is_empty&&secondTab.userReward!==undefined'
              v-model="selectType"
              :index-value="2"
              :text="`${(secondTab.number_type || {}).name}`"
              :append-amount="secondTab.userReward"
              @click="changeStatus(secondTab.number_type.id,secondTab.number_type.name)"
            ) 
    v-col(
      cols=12
      :class="!(firstTab.status||(!secondTab.Is_empty&&secondTab.status)) ? 'diable-all' :''"
    )
      v-row(no-gutters)
        v-col.px-1(cols='12', md='4')
          card-sequence-number(v-model='selectNineteen', title='19 ประตู', @click='addNineteen')
        v-col.px-1(cols='12', md='4')
          card-sequence-number(v-model='selectFrontRoot', title='รูดหน้า', @click='addFrontRoot')
        v-col.px-1(cols='12', md='4')
          card-sequence-number(v-model='selectBackRoot', title='รูดหลัง', @click='addBackRoot')
      v-row.mt-3(no-gutters)
        v-col.px-1(cols='12', md='7')
          v-row(no-gutters)
            v-card.py-3(flat width='100%')
              v-row.mx-1(no-gutters)
                v-col.column-five(
                  v-for='(item,i) in selectAmountList'
                  :key='i'
                )
                  v-btn-toggle.d-block.ma-1(
                    v-model='selectAmount'
                    color='var(--bg-secondary-color)'
                    multiple
                    borderless
                  )
                    v-btn.notranslate.force-round(
                      block
                      :value='item.value'
                      :color='checkLimitCondition(item)'
                      :disabled='checkDisable(item)'
                      @click='addValue(item)'
                    ) {{ checkDisable(item) ? $t('button.out-of-stock') : item.number }}
          v-row(no-gutters)
            limitlistcard(
              :first-tab='firstTab'
              :first-tab-status='firstTab.status'
              :second-tab='secondTab'
              :second-tab-status='secondTab.status'
            )
        v-col.px-1(cols='12', md='5')
          v-card.text-center.py-3(flat='')
            h4 {{ $t('enter-number') }}
            v-row.mx-3(no-gutters='')
              v-col.px-1
                n-number-field-specific(v-model='digitNumber1', readonly='')
              v-col.px-1
                n-number-field-specific(v-model='digitNumber2', readonly='')
            num-pad(
              :method-digit='addDigit' 
              :is-disable="!(firstTab.status||(!secondTab.Is_empty&&secondTab.status))"
              @removeLastNumber='removeLastNumber'
              @clearAll='clearAll'
              @removeDigit='removeDigit'
            )
          slot

</template>
<script>  
import numPad from './NumPad'  
import limitlistcard from './LimitList'
import CardSequenceNumber from '@/components/Card/CardSequenceNumber-LottoGame'
import * as c from '@/const/setTimeOutConfig'  
export default {
  components :{ 
    CardSequenceNumber,
    numPad, 
    limitlistcard
  },
  props : {
    switchToggle : {
      type:Boolean,
      default:false
    },

    indexSelect : { 
      type:Number,
      default:0
    },

    firstTab : {
      type:[Object,Boolean],
      default:()=>{
        return {
          limit_conditions : []
        }
      }
    },
    secondTab: {
      type:[Object,Boolean],
      default:()=>{
        return {
          status : false,
          Is_empty : true,

          limit_conditions : []
        }
      }
    },
    userSelect:{
      type:Array,
      default:()=>{
        return[]
      }
    },  
    voucher:{
      type:Object,
      default:()=>{}
    },

    filterNumber:{
      type:String,
      default:()=>''
    },  
  }, 
  data () {
    return { 
      selectAmount:[],
      selectNineteen:[],
      selectFrontRoot:[],
      selectBackRoot:[], 
      digitNumber1:'',
      digitNumber2:'',   
      selectType : [], 
      selectAmountBase : [],
      LIMITL : 2, 
      ALMOST : 1, 
      NORMAL : 0
    }
  },  
  
  computed : {
    selectAmountList () {  
      return  this.filterNumber ? 
              this.selectAmountBase.filter(x=>x.number.includes(this.filterNumber)) : 
              this.selectAmountBase
    } 
  },

  watch : {  
    indexSelect () { 
      this.initLimitCondition()
      this.checkStatusActive()
    },
    userSelect () {  
      this.checkStatusActive()
    },
    digitNumber2 (){
      var value = this.digitNumber1.toString()+this.digitNumber2.toString() 
      let item = this.selectAmountBase.find(x=>x.number===value)
      if(item && !this.selectAmount.includes(item.value)&&this.digitNumber2.length!==0){
        setTimeout(()=>{
          this.addValue(item)
          this.selectAmount.push(item.value) 
          this.digitNumber1=''
          this.digitNumber2=''
        },c.COUNTDOWNONESEC) 
      }
      else if(item && this.digitNumber2.length!==0 ){
        this.$noty.error(this.$t('already-select-number',{number:item.value}))   
        this.digitNumber1=''
        this.digitNumber2=''
      }
    }, 
  },
  async created () {  
    this.checkStatusActive() 
    this.initLimitCondition()
  },

  methods : {    
    initLimitCondition () {    
      this.selectAmountBase = Array.from(Array(100).keys()).map(x=>{
        let firstLimitFind = []
        let secondLimitFind = []
        let result = {
          value : x,
          number : this.changeNumbertoString(x),
          first : this.NORMAL,
          second : this.NORMAL,
          userReward_first : 0,
          userReward_second : 0
        } 
        if(this.firstTab) {
          firstLimitFind = this.firstTab.limit_conditions.filter(x=>x.number===result.number) 
        }
        if(this.secondTab) {
          secondLimitFind = this.secondTab.limit_conditions.filter(x=>x.number===result.number)  
        }
 
        if(firstLimitFind.length !==0){   
          let reward = Math.min.apply(Math,firstLimitFind.map(x=>x.quota_reward))  
          result.first = reward===0 ? this.LIMITL : this.ALMOST 
          result.userReward_first = reward
        }
        if(secondLimitFind.length !==0){  
          let reward = Math.min.apply(Math,secondLimitFind.map(x=>x.quota_reward))   
          result.second = reward===0 ? this.LIMITL : this.ALMOST
          result.userReward_second = reward
        } 
        return result
      })   
    }, 
 
    checkDisable (item) {
      let check = this.secondTab.status ? item.second : this.firstTab.status ? item.first : null
      if(this.secondTab.status && this.firstTab.status) {
        check = Math.max(item.first,item.second)
      }
      return check === this.LIMITL ? true : false
    },

    checkLimitCondition (item) {  
      let check = this.secondTab.status ? item.second : this.firstTab.status ? item.first : null
      if(this.secondTab.status && this.firstTab.status) {
        check = Math.max(item.first,item.second)
      }
      switch(check){
        case this.NORMAL:
          return ''
        case this.ALMOST:
          return 'red'
      }
      return '' 
    },  
     

    removeLastNumber () {
      this.$emit('removeLastNumber')
    },

    clearAll () { 
      this.$emit('clearAll')
    },

    removeDigit (){
        this.digitNumber1=''
    },

    addDigit (number){
      if(this.digitNumber1.length===0){
          this.digitNumber1 = number
      }else{
          this.digitNumber2 = number
      }  
    },

    resetBoardDisplay () { 
      this.selectType = []
      this.selectAmount = []
      this.selectNineteen = []
      this.selectFrontRoot = []
      this.selectBackRoot = []
    },

    addSelectValue (arrayValue) { 
      arrayValue.forEach(element => {
        if(!this.selectNineteen.includes(element.selectNineteen)){
            this.selectNineteen.push(element.selectNineteen)
        } 
        if(!this.selectFrontRoot.includes(element.selectFrontRoot)){
            this.selectFrontRoot.push(element.selectFrontRoot)
        } 
        if(!this.selectBackRoot.includes(element.selectBackRoot)){
            this.selectBackRoot.push(element.selectBackRoot)
        }  
      }); 
    },

    checkStatusActive () {   
      var filter = []
      this.resetBoardDisplay() 
      this.selectType = this.firstTab.status && this.secondTab.status? [1,2] 
      : this.firstTab.status ? [1] 
      : this.secondTab.status ? [2] 
      : [] 
      this.userSelect.forEach(element => {
        if((element.number_type_id===this.firstTab.number_type.id && this.firstTab.status) ||
          (element.number_type_id===this.secondTab.number_type.id && this.secondTab.status)) {
          filter.push(element)
          this.selectAmount.push(parseInt(element.number))
        }
      }); 
      this.addSelectValue (filter) 
    },

    changeStatus (id,amountDigit,name) {  
      this.$ga.event('Button', 'ToggleSelectType', 'TwoDigitPage', name)
      this.$emit('changeStatus',id)
      this.checkStatusActive ()
    },    

    switchNumbertoString (value){ 
      let number = this.changeNumbertoString(value).split("").reverse().join("")
      var result
      if(number[0] === number[1]) {
        result = [this.changeNumbertoString(value)]
        return result.map(x=>this.selectAmountBase.find(y=>y.number===x))  
      }
      
      result = [this.changeNumbertoString(value),number ]
      
      return result.map(x=>this.selectAmountBase.find(y=>y.number===x)) 
    }, 

    changeNumbertoString (value){ 
      return value<10? "0"+value.toString() : value.toString()  
    },

    addNineteen (value) {     
      this.$ga.event('Button', 'Add&DeleteNineteen', 'TwoDigitPage', value)
      var valuToString = value.toString()
      var arrayResult = Array(20).fill().map((_,index)=>{  
        if(index<10&&value!==index){  
          return this.selectAmountBase.find(y=>y.number===valuToString+index) 
        } else if(value!==index){  
          return this.selectAmountBase.find(y=>y.number===(index-10)+valuToString) 
        }  
      })    
      this.loopAdd(arrayResult,value,null,null) 
    },

    addFrontRoot (value) {  
      this.$ga.event('Button', 'Add&DeleteFrontRoot', 'TwoDigitPage', value)
      var valuToString = value.toString() 
      var arrayResult = Array(10).fill().map((_,index)=>{   
        return this.selectAmountBase.find(y=>y.number===valuToString+index)  
      })    
      this.loopAdd(arrayResult,null,value,null)  
    },

    addBackRoot (value) {  
      this.$ga.event('Button', 'Add&DeleteBackRoot', 'TwoDigitPage', value)
      var valuToString = value.toString() 
      var arrayResult = Array(10).fill().map((_,index)=>{   
        return this.selectAmountBase.find(y=>y.number===index+valuToString)  
      })    
      this.loopAdd(arrayResult,null,null,value)   
    },

    async addValue (item){
      var changeNumbertoString = item.number
      // if(this.selectAmount.includes(item.value)) {  
      //   const result =  await this.$confirm('','คุณต้องการยกเลิกเลขนี้ใช่หรือไม่','warning') 
      //   if(!result){   
      //     return
      //   }
      // }   
      this.$ga.event('Button', 'Add&DeleteValue', 'TwoDigitPage', changeNumbertoString)
      var arrayResult = this.switchToggle && !this.selectAmount.includes(item.value) 
      ? this.switchNumbertoString (item.value)
      : [changeNumbertoString].map(x=>this.selectAmountBase.find(y=>y.number===x))  
      this.loopAdd(arrayResult,null,null,null) 
    }, 

    loopAdd (array,selectNineteen,selectFrontRoot,selectBackRoot) {     
      
      let Bypass = false 
      let stakeMaxNumber = (this.voucher.rules || {}).stake_max_number
      let checkVoucherStake = this.voucher.rules && stakeMaxNumber
      
      array.forEach(e=>{ 
        if(!e) {
          return
        }   
        
        var status = selectNineteen!==null 
        ? this.selectNineteen.includes(selectNineteen) 
        : selectFrontRoot!==null 
        ? this.selectFrontRoot.includes(selectFrontRoot) 
        : selectBackRoot!==null 
        ? this.selectBackRoot.includes(selectBackRoot) 
        : this.selectAmount.includes(e.value) 
        
        var actionStatus = status ? 'delValue': 'addValue' 
        
        if( checkVoucherStake &&
            this.userSelect.length >= parseInt(stakeMaxNumber) &&
            actionStatus === 'addValue'
          ){ 
          if(!Bypass) {  
            this.$nextTick(()=>{
              this.checkStatusActive() 
            }) 
          }
          
          Bypass = true
          return
        } 
        
        if(this.firstTab.status && e.first !== this.LIMITL ){  
          let price = e.first === this.NORMAL ? this.firstTab.userReward : e.userReward_first
          this.$emit(actionStatus,price,e.number,this.firstTab.number_type.id,selectNineteen,selectFrontRoot,selectBackRoot)
        }
        if(this.secondTab.status && e.second !== this.LIMITL ) { 
          let price = e.second === this.NORMAL ? this.secondTab.userReward : e.userReward_second
          this.$emit(actionStatus,price,e.number,this.secondTab.number_type.id,selectNineteen,selectFrontRoot,selectBackRoot)
        } 
      }) 
    } 
  }
} 
</script>     